import React, { Component } from 'react';
import { connect } from 'react-redux';

import { POS_MAX_ZOOM_LEVEL, MAX_RESULT } from '../../settings/pointOfSale';

import { fetchSearchResults, zoomChanged } from '../../actions/pointOfSale'
import { DISPLAY_MODE_LIST } from 'ui-kit/src/components/FilterBlock/FilterBlock';

import ResultsBlock, { HIDE_RESULTS, SHOW_RESULTS } from 'ui-kit/src/components/ResultsBlock/ResultsBlock';
import StatefulShopBlock from '../StatefulShopBlock/StatefulShopBlock';

class StatefulResultsBlock extends Component {
  componentWillUpdate(nextProps) {
    if (nextProps.markers !== this.props.markers && nextProps.markers.length <= MAX_RESULT) {
      // Fetch search results.
      nextProps.fetchSearchResults(nextProps.markers);
    }
  }

  formatShop(item, number) {
    return {
      element: <StatefulShopBlock shop={item} label={number} displayItinerary={true} />,
      id: item.id
    };
  }

  render() {
    let tooFar = false;
    let state = HIDE_RESULTS;
    if (this.props.displayMode === DISPLAY_MODE_LIST) {
      state = SHOW_RESULTS;
    }

    let diorShops = this.props.searchResultsDior;
    let otherShops = this.props.searchResultsOther;

    if (this.props.itinerary) {
      if (this.props.selectedItem.typeParent === 'Dior') {
        diorShops = [this.props.selectedItem];
        otherShops = [];
      } else {
        diorShops = [];
        otherShops = [this.props.selectedItem];
      }
    }

    diorShops = diorShops.map((item, index) => this.formatShop(item, index + 1));
    const length = Object.keys(diorShops).length;
    otherShops = otherShops.map((item, index) => this.formatShop(item, index + length + 1));

    if (this.props.visibleMarkerIds.length > MAX_RESULT && !this.props.itinerary) {
      diorShops = [];
      otherShops = [];
      tooFar = true;
    }

    return (<ResultsBlock
      diorShops={diorShops}
      displayResults={state}
      styles={this.props.style}
      maxZoom={POS_MAX_ZOOM_LEVEL}
      onZoom={this.props.zoomChanged}
      otherShops={otherShops}
      selectedId={this.props.selectedId}
      tooFar={tooFar}
      zoom={this.props.zoom}
    />);
  }
}

const mapStateToProps = (state) => {
  return {
    categoryOpen: state.pointOfSale.categoryOpen,
    center: state.pointOfSale.center,
    displayType: state.shared.displayType,
    displayMode: state.shared.displayMode,
    isOpen: state.shared.filtersIsOpen,
    itinerary: state.pointOfSale.itinerary,
    markers: state.pointOfSale.markers,
    searchResultsDior: state.pointOfSale.searchResults.filter(item => item.typeParent === 'Dior'),
    searchResultsOther: state.pointOfSale.searchResults.filter(item => item.typeParent !== 'Dior'),
    selectedId: state.pointOfSale.selectedId,
    selectedItem: state.pointOfSale.selectedItem,
    visibleMarkerIds: state.pointOfSale.visibleMarkerIds,
    zoom: state.pointOfSale.zoom
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSearchResults: fetchSearchResults.bind(null, dispatch),
    zoomChanged: zoomChanged.bind(null, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(StatefulResultsBlock);



// WEBPACK FOOTER //
// ./src/components/StatefulResultsBlock/StatefulResultsBlock.jsx